export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.provide('smoothScroll', (selector) => {
    const element = document.querySelector(selector)
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      })
    }
  })
})